import type {
  LoadFlowScenarioElementCalculation,
  LoadFlowScenarioResults
} from '..';
import type { GridElementObjectTypes } from '../derived-state/gridElementsDetailsByCalculationType/GridElementType';

export const selectByTypeFromAllScenarios = <
  TGridElementType extends GridElementObjectTypes
>(
  gridElementType: TGridElementType,
  loadFlowScenarios: LoadFlowScenarioResults[]
) =>
  loadFlowScenarios.flatMap(scenario =>
    selectByType(gridElementType, scenario.results)
  );

export const selectByType = <TGridElementType extends GridElementObjectTypes>(
  gridElementType: TGridElementType,
  loadFlowResults: LoadFlowScenarioElementCalculation[]
) =>
  loadFlowResults
    .filter(scenarioResult => scenarioResult.objectType === gridElementType)
    .map(scenarioResult => {
      const gridElementResults = scenarioResult as unknown as Extract<
        LoadFlowScenarioElementCalculation,
        { objectType: TGridElementType }
      >;
      return gridElementResults;
    });
